import { Question, QuestionOption } from '../types/assessment';

export const assessmentQuestions: Question[] = [
  // 1. Identita / aspirace
  {
    id: 'q1_identity',
    type: 'single_choice',
    title: 'Představ si sám sebe za 3–6 měsíců. Kým jsi se stal?',
    description: 'Neexistuje správná odpověď. Odpovídej tak, jak to teď cítíš.',
    options: [
      { value: 'direction', label: 'Člověkem, který má jasný směr.' },
      { value: 'calm', label: 'Člověkem, který má víc klidu v hlavě.' },
      { value: 'self_reliant', label: 'Člověkem, který se umí opřít sám o sebe.' },
      { value: 'boundaries', label: 'Člověkem, který umí říkat ne.' },
      { value: 'decisive', label: 'Člověkem, který se umí rozhodnout.' },
      { value: 'finisher', label: 'Člověkem, který dotahuje.' }
    ],
    validation: { required: true },
    category: 'goals'
  },

  // 2. Co teď chceš řešit nejvíc?
  {
    id: 'q2_focus_area',
    type: 'single_choice',
    title: 'Co teď chceš řešit nejvíc?',
    description: 'Čím vyšší urgence, tím víc dává smysl jít po jednoduchých krocích, ne po dokonalém plánu.',
    options: [
      { value: 'direction_goal', label: 'Směr / dlouhodobý cíl' },
      { value: 'work_life_balance', label: 'Work-life balance / přetížení' },
      { value: 'confidence_communication', label: 'Sebedůvěra / komunikace / hranice' },
      { value: 'decision', label: 'Rozhodnutí (práce, vztah, škola…)' },
      { value: 'performance', label: 'Výkon / disciplína / produktivita' },
      { value: 'emotions_stress', label: 'Emoce / stres / vnitřní klid' },
      { value: 'acute_situation', label: 'Naléhavá situace (konflikt, pohovor, zkouška…)' },
      { value: 'other', label: 'Jiné' }
    ],
    validation: { required: true },
    category: 'stress'
  },

  // 3. Akutní situace (podmíněně)
  {
    id: 'q3_acute_desc',
    type: 'text',
    title: 'O jakou situaci se jedná?',
    description: 'Krátce popiš, co tě čeká.',
    validation: { required: false }, // Volitelné
    category: 'stress',
    condition: (responses) => responses['q2_focus_area'] === 'acute_situation'
  },
  {
    id: 'q3_other_focus_desc',
    type: 'text',
    title: 'Co konkrétně chceš řešit?',
    description: 'Když jsi vybral/a "Jiné", napiš prosím krátce vlastními slovy, o co jde.',
    validation: { required: true, min_length: 3 },
    category: 'stress',
    condition: (responses) => responses['q2_focus_area'] === 'other'
  },

  // 4. Jak rychle s tím chceš pohnout?
  {
    id: 'q4_urgency',
    type: 'single_choice',
    title: 'Jak rychle s tím chceš pohnout?',
    options: [
      { value: 'now', label: 'Teď hned (v řádu dnů)' },
      { value: 'weeks', label: 'V příštích 2–4 týdnech' },
      { value: 'months', label: 'V příštích 2–3 měsících' },
      { value: 'exploring', label: 'Jen mapuju možnosti / rozhlížím se' },
      { value: 'unsure', label: 'Chci s tím pohnout, ale upřímně nevím, jestli to dám.' }
    ],
    validation: { required: true },
    category: 'goals'
  },

  // 5. Vyber max 3 oblasti
  {
    id: 'q5_life_areas',
    type: 'multiple_choice',
    title: 'Vyber max 3 oblasti, které chceš teď zlepšit.',
    options: [
      { value: 'career', label: 'Kariéra / práce' },
      { value: 'finance', label: 'Finance' },
      { value: 'friends', label: 'Přátelé / komunita' },
      { value: 'family', label: 'Rodina' },
      { value: 'partner', label: 'Partnerství / láska' },
      { value: 'hobbies', label: 'Volný čas / koníčky' },
      { value: 'growth', label: 'Osobní rozvoj / seberealizace' },
      { value: 'health', label: 'Zdraví / tělo' },
      { value: 'spirituality', label: 'Smysl / duchovno' },
      { value: 'other', label: 'Jiné' }
    ],
    validation: { required: true, max_selections: 3 },
    category: 'perma'
  },
  {
    id: 'q5_other_area_desc',
    type: 'text',
    title: 'Jaká jiná oblast je pro tebe důležitá?',
    description: 'Napiš ji prosím vlastními slovy.',
    validation: { required: true, min_length: 3 },
    category: 'perma',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('other')
  },

  // 6. Spokojenost s vybranými oblastmi (Dynamicky generované otázky)
  {
    id: 'q6_satisfaction_career',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Kariéra / práce?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'perma',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('career')
  },
  {
    id: 'q6_satisfaction_finance',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Finance?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'perma',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('finance')
  },
  {
    id: 'q6_satisfaction_friends',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Přátelé / komunita?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'perma',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('friends')
  },
  {
    id: 'q6_satisfaction_family',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Rodina?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'perma',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('family')
  },
  {
    id: 'q6_satisfaction_partner',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Partnerství / láska?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'perma',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('partner')
  },
  {
    id: 'q6_satisfaction_hobbies',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Volný čas / koníčky?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'sdt', // Or PERMA depending on classification
    condition: (responses) => (responses['q5_life_areas'] || []).includes('hobbies')
  },
  {
    id: 'q6_satisfaction_growth',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Osobní rozvoj / seberealizace?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'sdt',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('growth')
  },
  {
    id: 'q6_satisfaction_health',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Zdraví / tělo?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'sdt',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('health')
  },
  {
    id: 'q6_satisfaction_spirituality',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Smysl / duchovno?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'mindset',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('spirituality')
  },
  {
    id: 'q6_satisfaction_other',
    type: 'scale',
    title: 'Jak jsi aktuálně spokojen/a s: Jiná oblast?',
    scale: { min: 1, max: 10, min_label: 'Vůbec', max_label: 'Naprosto' },
    validation: { required: true },
    category: 'perma',
    condition: (responses) => (responses['q5_life_areas'] || []).includes('other')
  },

  // 7. Priorita #1
  {
    id: 'q7_priority_area',
    type: 'single_choice',
    title: 'Která z vybraných oblastí je pro tebe priorita #1?',
    description: 'Většina lidí má jednu oblast, která brzdí všechno ostatní. Teď zjistíme, proč se to děje.',
    options: [], // Dynamic options
    dynamicOptions: (responses) => {
      const selectedAreas = responses['q5_life_areas'] || [];
      const allOptions = [
        { value: 'career', label: 'Kariéra / práce' },
        { value: 'finance', label: 'Finance' },
        { value: 'friends', label: 'Přátelé / komunita' },
        { value: 'family', label: 'Rodina' },
        { value: 'partner', label: 'Partnerství / láska' },
        { value: 'hobbies', label: 'Volný čas / koníčky' },
        { value: 'growth', label: 'Osobní rozvoj / seberealizace' },
        { value: 'health', label: 'Zdraví / tělo' },
        { value: 'spirituality', label: 'Smysl / duchovno' },
        { value: 'other', label: 'Jiné' }
      ];
      return allOptions.filter(opt => selectedAreas.includes(opt.value));
    },
    validation: { required: true },
    category: 'goals',
    condition: (responses) => (responses['q5_life_areas'] || []).length > 1
  },
  {
    id: 'q7_priority_other_desc',
    type: 'text',
    title: 'Co je v této jiné prioritě to hlavní?',
    description: 'Krátce popiš, co je pro tebe v této oblasti nejdůležitější.',
    validation: { required: true, min_length: 3 },
    category: 'goals',
    condition: (responses) => {
      const isPriorityOther = responses['q7_priority_area'] === 'other';
      const isOnlyAreaOther = (responses['q5_life_areas'] || []).length === 1 && (responses['q5_life_areas'] || [])[0] === 'other';
      return isPriorityOther || isOnlyAreaOther;
    }
  },

  // 8. Příčina tlaku
  {
    id: 'q8_pressure_source',
    type: 'single_choice',
    title: 'Když jsi poslední dobou pod tlakem, co bývá nejčastější příčina?',
    options: [
      { value: 'short_term', label: 'Konkrétní krátkodobá věc (deadline, hádka, zkouška…)' },
      { value: 'long_term', label: 'Dlouhodobý tlak (práce, finance, péče o někoho…)' },
      { value: 'environment', label: 'Prostředí / lidi kolem (chaos, toxická kultura, konflikty)' },
      { value: 'unknown', label: 'Nevím / střídá se to' }
    ],
    validation: { required: true },
    category: 'stress'
  },

  // 9. Mindset
  {
    id: 'q9_mindset_growth',
    type: 'single_choice',
    title: 'Které tvrzení je ti bližší?',
    options: [
      { value: 'fixed', label: 'Spíš: „Můžu se učit a zlepšovat, ale moje základní schopnosti jsou spíš dané.“' },
      { value: 'growth', label: 'Spíš: „S úsilím a správnou strategií se dokážu výrazně zlepšit.“' }
    ],
    validation: { required: true },
    category: 'mindset'
  },

  // 10. Co tě brzdí
  {
    id: 'q10_action_block',
    type: 'single_choice',
    title: 'Co tě nejčastěji brzdí v akci?',
    description: 'Další otázky vychází z výzkumu motivace. Pomůžou nám doporučit to, co ti bude fungovat.',
    options: [
      { value: 'overwhelmed', label: 'Přetížení / málo času' },
      { value: 'perfectionism', label: 'Perfekcionismus / strach ze selhání' },
      { value: 'chaos', label: 'Chaos v prioritách / disciplína' },
      { value: 'low_energy', label: 'Nízká energie / psychická únava' },
      { value: 'boundaries', label: 'Tlak okolí / neumím hranice' },
      { value: 'stuck', label: 'Nevím, jen se „nemůžu pohnout“' },
      { value: 'other', label: 'Jiné' }
    ],
    validation: { required: true },
    category: 'stress'
  },
  {
    id: 'q10_action_block_other_desc',
    type: 'text',
    title: 'Co tě tedy brzdí nejvíc?',
    description: 'Když jsi vybral/a "Jiné", napiš prosím stručně vlastní odpověď.',
    validation: { required: true, min_length: 3 },
    category: 'stress',
    condition: (responses) => responses['q10_action_block'] === 'other'
  },

  // 11. Autonomie
  {
    id: 'q11_control_scale',
    type: 'scale',
    title: 'Do jaké míry teď platí: „Mám prostor řídit si život podle sebe (ne jen reagovat).“',
    scale: { min: 1, max: 7, min_label: 'Vůbec', max_label: 'Velmi' },
    validation: { required: true },
    category: 'sdt'
  },

  // 12. Kompetence
  {
    id: 'q12_progress_scale',
    type: 'scale',
    title: 'Do jaké míry teď platí: „Mám pocit, že se mi daří a že se reálně posouvám (nejen se snažím).“',
    scale: { min: 1, max: 7, min_label: 'Vůbec', max_label: 'Velmi' },
    validation: { required: true },
    category: 'sdt'
  },

  // 13. Vztahy (Support)
  {
    id: 'q13_support_scale',
    type: 'scale',
    title: 'Do jaké míry teď platí: „Mám kolem sebe lidi, o které se můžu opřít.“',
    scale: { min: 1, max: 7, min_label: 'Vůbec', max_label: 'Velmi' },
    validation: { required: true },
    category: 'sdt'
  },

  // 14. Signál úspěchu
  {
    id: 'q14_success_signal',
    type: 'single_choice',
    title: 'Podle čeho bys za 2–3 měsíce poznal/a, že se něco opravdu pohnulo?',
    options: [
      { value: 'direction', label: 'Mám jasně pojmenovaný směr nebo další krok.' },
      { value: 'calm', label: 'Cítím méně vnitřního tlaku a nejsem tak zahlcený/á jako teď.' },
      { value: 'boundaries', label: 'Dokážu si nastavit hranice a říkat „ne“ bez pocitu viny.' },
      { value: 'stress_management', label: 'Zvládám stres a emoce lépe v běžných situacích, nejen v ideálním týdnu.' },
      { value: 'decision_made', label: 'Udělal/a jsem jedno nebo více konkrétních rozhodnutí, kterým jsem se vyhýbal/a.' },
      { value: 'career_progress', label: 'Je vidět posun v mé práci nebo kariéře (výkon, role, směr).' },
      { value: 'clarity_needed', label: 'Nevím – potřebuji si nejdřív ujasnit, co by pro mě „úspěch“ vlastně znamenal.' }
    ],
    validation: { required: true },
    category: 'goals'
  },

  // 15. Běžný týden
  {
    id: 'q15_weekly_feel',
    type: 'single_choice',
    title: 'Když se podíváš na běžný týden, spíš…',
    options: [
      { value: 'nonstop', label: 'Jedu nonstop, pořád nestíhám.' },
      { value: 'balanced', label: 'Je to tak akorát. Mám čas na práci i na své blízké a zájmy.' },
      { value: 'wasted', label: 'Mám čas, ale často ho promrhám nebo nevím, kam zmizel.' }
    ],
    validation: { required: true },
    category: 'stress' // or time_management
  },

  // 16. Časová investice
  {
    id: 'q16_time_investment',
    type: 'single_choice',
    title: 'Kolik času týdně do sebe reálně chceš investovat?',
    description: 'Radši vyber realisticky než ideálně — plán tomu přizpůsobíme.',
    options: [
      { value: '30min', label: 'Do 30 minut (mikrokroky)' },
      { value: '1h', label: '1 hodina' },
      { value: '2h', label: '2 hodiny' },
      { value: '3h_plus', label: '3+ hodin' },
      { value: 'recommend', label: 'Nevím / potřebuju doporučit' }
    ],
    validation: { required: true },
    category: 'goals'
  },

  // 17. Forma podpory
  {
    id: 'q17_support_preference',
    type: 'single_choice',
    title: 'Jaká forma podpory ti sedí nejvíc?',
    options: [
      { value: 'self_help', label: 'Chci konkrétní plán a projít si to sám/sama (self-help)' },
      { value: 'group', label: 'Chci jemné vedení + komunitu (skupina)' },
      { value: 'individual', label: 'Chci 1:1 podporu (kouč / mentor / terapeut)' },
      { value: 'recommend', label: 'Nevím – doporučte mi' }
    ],
    validation: { required: true },
    category: 'demographics'
  },

  // 18. Zkušenost
  {
    id: 'q18_experience',
    type: 'single_choice',
    title: 'Máš zkušenost s koučinkem / terapií / mentoringem?',
    description: 'Ptáme se, abychom doporučili vhodný styl podpory.',
    options: [
      { value: 'no', label: 'Ne' },
      { value: 'yes_good', label: 'Ano a bylo to přínosné' },
      { value: 'yes_bad', label: 'Ano a nebylo to dobré' },
      { value: 'neutral', label: 'Nechci říct / nevím' }
    ],
    validation: { required: true },
    category: 'demographics'
  }
];

// Progress messages for different completion stages
export const progressMessages = {
  25: "Skvěle, máme základní mapu tvých priorit.",
  50: "Jsme v polovině. Teď jdeme do hloubky.",
  75: "Už jen pár otázek k nastavení podpory.",
  100: "Perfektní! Analyzujeme tvé odpovědi."
};

// Educational content for interstitials
export const educationalContent = {
  after_perma: {
    title: "Věděl/a jsi?",
    content: "První část mapuje tvoji spokojenost. Často stačí malý posun v jedné oblasti, aby se zvedla spokojenost v celém životě."
  },
  after_sdt: {
    title: "Zajímavost",
    content: "Tvoje odpovědi nám pomáhají pochopit, co tě motivuje a co tě naopak brzdí. Díky tomu bude plán opravdu tvůj."
  },
  after_mindset: {
    title: "Dík za důvěru",
    content: "Už jen kousek. Teď doladíme detaily spolupráce."
  }
};

// Question categories for progress tracking
export const questionCategories = {
  hook: [0, 1, 2, 3],
  perma: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], // Indices will vary due to dynamic nature
  sdt: [14, 15, 16],
  mindset: [12, 13],
  stress: [1, 7, 9, 14],
  goals: [0, 3, 6, 17, 19],
  demographics: [20, 21]
};
